import axios from "axios";
import jsonp from "jsonp-promise";
import { Singleton } from "util";
import BaseService from "./base.service";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class CustomerService extends BaseService {
  async getCnpjInfo(cnpj) {
    try {
      const cnpjResponse = await jsonp(
        `https://www.receitaws.com.br/v1/cnpj/${cnpj}`
      ).promise;

      if (cnpjResponse) {
        const response = {
          success: true,
          email: cnpjResponse.email,
          tradingName: cnpjResponse.fantasia,
          name: cnpjResponse.nome,
          phonenumber: cnpjResponse.telefone,

          zipcode: cnpjResponse.cep.replace(/\D/g, ""),
          addressAdditional:
            cnpjResponse.complemento.length === 0
              ? "S/C"
              : cnpjResponse.complemento,
          state: cnpjResponse.uf,
          address: cnpjResponse.logradouro,
          neighborhood: cnpjResponse.bairro,
          city: cnpjResponse.municipio,
          addressNumber: cnpjResponse.numero
        };

        const zipcodeInfo = await this.getZipcodeInfo(response.zipcode);
        if (zipcodeInfo.success) {
          response.cityCode = zipcodeInfo.cityCode;
        }

        return response;
      }
    } catch (e) {
      // DO NOTHING
    }

    return { success: false };
  }

  async getZipcodeInfo(zipcode) {
    try {
      const cepResponse = await axios.get(
        `https://viacep.com.br/ws/${zipcode}/json/`
      );

      if (cepResponse && cepResponse.data) {
        return {
          success: true,
          neighborhood: cepResponse.data.bairro,
          address: cepResponse.data.logradouro,
          city: cepResponse.data.localidade,
          state: cepResponse.data.uf,
          cityCode: cepResponse.data.ibge,
          addressAdditional: cepResponse.data.complemento
        };
      }
    } catch (e) {
      // DO NOTHING
    }

    return { success: false };
  }

  async fetch(companyUuid, { filters, order, pagination }) {
    const url = `/v1/companies/${companyUuid}/customers`;
    const resourceRoute = ApiResourceBuilder.buildFromParams(url, {
      filters,
      order,
      pagination
    });
    return await this.get(resourceRoute);
  }

  async fetchByUuid(companyUuid, uuid) {
    return await this.get(`/v1/companies/${companyUuid}/customers/${uuid}`);
  }

  async update(companyUuid, uuid, params) {
    return await super.update(
      `/v1/companies/${companyUuid}/customers/${uuid}`,
      params
    );
  }

  async create(companyUuid, params) {
    return await this.post(`/v1/companies/${companyUuid}/customers`, params);
  }

  async delete(companyUuid, uuid) {
    return await this.destroy(`/v1/companies/${companyUuid}/customers/${uuid}`);
  }
}

export default CustomerService;



// WEBPACK FOOTER //
// ./src/core/service/customer.service.js